<section class="flowpay-third-party-wrapper">
  <div class="box-container">
    <!-- content -->
    <div class="box">
      <div class="box__left">
        <div class="stripe-logo">
          <img src="https://flowaccountcdn.com/images/payment/Stripe_v1.png" height="40" alt="stripe-logo" />
        </div>

        <div class="title" [innerHtml]="'FLOWPAY.THIRD_PARTY_PAYMENT.HEADING' | translate"></div>

        <div class="detail">{{ 'FLOWPAY.THIRD_PARTY_PAYMENT.DETAIL' | translate }} </div>
      </div>

      <div class="box__right">
        <!-- <div class="box__tab">
          <div class="item active" [ngClass]="{ active: thirdPartyChannel === flowpayThirdPartyEnum.Stripe }"
            (click)="onClickTab(flowpayThirdPartyEnum.Stripe)">
            <img src="https://flowaccountcdn.com/images/payment/Stripe_v1.png" height="30" alt="" />
          </div>
          <div class="item" [ngClass]="{ active: thirdPartyChannel === flowpayThirdPartyEnum.Omise }"
            (click)="onClickTab(flowpayThirdPartyEnum.Omise)"><img
              src="https://flowaccountcdn.com/images/payment/Omise.png" height="30" alt="" /></div>
        </div> -->
        <div *ngIf="thirdPartyChannel === flowpayThirdPartyEnum.Stripe" class="box__card">
          <ng-container *ngFor="let item of loopArray(7); let i = index">
            <div class="box__card-detail"
              ><span class="icon-wrapper"><i class="fa fa-check"></i></span>
              <span
                [innerHtml]="'FLOWPAY.THIRD_PARTY_PAYMENT.STRIPE.TEXT_' + (i + 1) | translate: creditCardLogo"
              ></span>
            </div>
          </ng-container>

          <div class="box__link">
            <a href="https://stripe.com/th/pricing" rel="nofollow noopener" target="_blank">
              <span class="text">{{ 'FLOWPAY.THIRD_PARTY_PAYMENT.SEE_MORE' | translate }} </span>
              <i class="fas fa-angle-right"></i
            ></a>
          </div>
        </div>

        <div *ngIf="thirdPartyChannel === flowpayThirdPartyEnum.Omise" class="box__card">
          <ng-container *ngFor="let item of loopArray(4); let i = index">
            <div class="box__card-detail"
              ><span class="icon-wrapper"><i class="fa fa-check"></i></span>
              <span
                [innerHtml]="'FLOWPAY.THIRD_PARTY_PAYMENT.OMISE.TEXT_' + (i + 1) | translate: creditCardLogo"
              ></span>
            </div>
          </ng-container>

          <div class="box__link">
            <a href="https://www.omise.co/th/pricing/thailand" rel="nofollow noopener" target="_blank">
              <span class="text">{{ 'FLOWPAY.THIRD_PARTY_PAYMENT.SEE_MORE' | translate }} </span>
              <i class="fas fa-angle-right"></i
            ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
